import { render } from "./CustomerSegmentUpdate.vue?vue&type=template&id=1c0b9ac4&scoped=true"
import script from "./CustomerSegmentUpdate.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentUpdate.vue?vue&type=script&lang=js"

import "./CustomerSegmentUpdate.vue?vue&type=style&index=0&id=1c0b9ac4&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0b9ac4"]])

export default __exports__